import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { HeroWithBannerBlock as HeroWithBannerBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const HeroWithBannerBlock = (
    block: Immutable<{ value: HeroWithBannerBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.heroWithBannerBlock,
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        {block.value.header ? (
            <header>
                <h1>{block.value.header}</h1>
            </header>
        ) : null}
        {block.value.copy ? (
            <div className={styles.heroWithBannerBlockBanner}>
                <p>{block.value.copy}</p>
            </div>
        ) : null}
        {block.value.image ? (
            <picture>
                <source
                    media="(max-width: 578px)"
                    srcSet={
                        block.value.image.renditions["fill-450x477-c100"]
                            ?.url ?? block.value.image.url
                    }
                />
                <source
                    media="(min-width: 579px) and (max-width: 1200px)"
                    srcSet={
                        block.value.image.renditions["fill-1280x700-c25"]
                            ?.url ?? block.value.image.url
                    }
                />
                <img
                    src={
                        block.value.image.renditions["width-1600"]?.url ??
                        block.value.image.url
                    }
                    alt={block.value.image.title}
                />
            </picture>
        ) : null}
    </section>
);
